import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    redirect: "/maas",
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/index.vue")
      },
      {
        path: "/solution",
        name: "solution",
        component: () => import("@/views/Solution.vue")
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/Product.vue")
      },
      {
        path: "/case",
        name: "case",
        component: () => import("@/views/Case.vue")
      },
      {
        path: "/case/02",
        name: "case2",
        component: () => import("@/views/case/Case2.vue")
      },
      {
        path: "/case/03",
        name: "case3",
        component: () => import("@/views/case/Case3.vue")
      },
      {
        path: "/lab",
        name: "lab",
        component: () => import("@/views/Lab.vue")
      },
      {
        path: "/service",
        name: "service",
        component: () => import("@/views/Service.vue")
      },
      {
        path: "/service/serviceView",
        name: "serviceView",
        component: () => import("@/views/serviceComponents/serviceView.vue")
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/About.vue")
      },
      {
        path: "/solution/solutionView",
        name: "resource",
        component: () => import("@/views/Resource.vue")
      },
      {
        path: "/case/caseView",
        name: "caseView",
        component: () => import("@/views/caseView.vue")
      },
      {
        path: "/doctor",
        name: "doctor",
        component: () => import("@/views/Doctor.vue")
      },
      {
        path: "/space",
        name: "space",
        component: () => import("@/views/Space.vue")
      },
      {
        path: "/situation",
        name: "situation",
        component: () => import("@/views/Situation.vue")
      },
      {
        path: "/maas",
        name: "maas",
        component: () => import("@/views/Maas.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({y: 0}), //路由跳转后页面回到顶部
  routes
});

// const checkRouter = (routesItem, to) => {
//   for (const route of routesItem) {
//     if (route.path === to.path) {
//       return true;
//     }
//   }
//   return false;
// };

router.beforeEach((to, from, next) => {
  const routeMapping = {
    resource: "solution",
    serviceView: "service",
    caseView: "solution"
  };
  const routeName = routeMapping[to.name] || to.name;

  store.commit("menu/setActiveRoute", routeName);
  next();
});

// router.onError(() => {});
export default router;
